import { useState } from "react";

import { toast } from "react-toastify";
import { resetForm, generateMachineId } from "../components/machine/MachineUtils";
import { getErrorMessage } from "utils/ErrorMessage";
import {
  useFetchMachinesQuery, useCreateMachineMutation,
  useUpdateMachineMutation,
  useDeleteMachineMutation
} from "features/store";

export function useMachineOperations() {
  const { data: machinesData, isLoading, error: fetchError } = useFetchMachinesQuery();
  const [createMachine] = useCreateMachineMutation();
  const [updateMachine] = useUpdateMachineMutation();
  const [deleteMachine] = useDeleteMachineMutation();

  const [formData, setFormData] = useState({
    machine_id: "",
    machine_name: "",
    description: "",
    is_active: true,
  });
  const [editingMachine, setEditingMachine] = useState(null);

const handleFormSubmit = async (e, onSuccess) => {
  e.preventDefault();
  try {
    if (editingMachine) {
      await updateMachine({ id: editingMachine.id, ...formData }).unwrap();
      toast.success("Machine updated successfully!");
    } else {
      await createMachine(formData).unwrap();
      toast.success("Machine created successfully!");
      // Save machine_id to localStorage after successful registration
      if (formData.machine_id) {
        localStorage.setItem("machineId", formData.machine_id);
      }
    }
    resetForm(setFormData);
    setEditingMachine(null);
    if (onSuccess) onSuccess(); 
  } catch (err) {
    toast.error(getErrorMessage(err.data));
  }
};


  const handleDelete = async (machineId) => {
    try {
      await deleteMachine(machineId).unwrap();
      toast.success("Machine deleted successfully!");
    } catch (err) {
      toast.error(getErrorMessage(err.data));
    }
  };

  const openCreateForm = () => {
    resetForm(setFormData);
    setFormData((prev) => ({ ...prev, machine_id: generateMachineId() }));
    setEditingMachine(null);
  };

  const machines = machinesData?.results || machinesData || [];

  return {
    machines,
    isLoading,
    fetchError,
    formData,
    setFormData,
    editingMachine,
    setEditingMachine,
    handleFormSubmit,
    handleDelete,
    openCreateForm,
  };
}
